import DOMPurify from 'dompurify';

function isSafeHtmlUrl(value) {
  if (typeof value !== 'string') {
    return false;
  }
  const raw = value.trim();
  if (raw === '') {
    return false;
  }
  if (raw.startsWith('#') === true) {
    return true;
  }
  let parsedUrl;
  try {
    parsedUrl = new URL(raw, window.location.origin);
  } catch (e) {
    return false;
  }
  const protocol = typeof parsedUrl.protocol === 'string' ? parsedUrl.protocol.toLowerCase() : '';
  if (protocol === 'http:') {
    return true;
  }
  if (protocol === 'https:') {
    return true;
  }
  if (protocol === 'mailto:') {
    return true;
  }
  if (protocol === 'tel:') {
    return true;
  }
  return false;
}

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node !== null && node !== undefined && node.tagName === 'A') {
    const href = node.getAttribute('href');
    if (href !== null && href !== undefined && href.trim() !== '') {
      if (isSafeHtmlUrl(href) === true) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
      } else {
        node.removeAttribute('href');
      }
    }
  }
  if (node !== null && node !== undefined && node.tagName === 'IMG') {
    const src = node.getAttribute('src');
    if (src !== null && src !== undefined && src.trim() !== '') {
      if (isSafeHtmlUrl(src) !== true) {
        node.removeAttribute('src');
      }
    }
  }
});

export function sanitizeHtml(value) {
  const raw = typeof value === 'string' ? value : (value === null || value === undefined ? '' : String(value));
  if (raw.trim() === '') {
    return '';
  }
  return DOMPurify.sanitize(raw, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'svg', 'math'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'srcdoc']
  });
}
